<mat-card class="cmn-flex flex">
    <mat-card-content>
        <mat-card-title>Recipients</mat-card-title>
        <mat-card-subtitle>Enter {{subTitle()}}</mat-card-subtitle>
        <div class="cmn-flex column">
            <div *ngIf="showGroupField" class="field-container">
                <div class="recipient-label">
                    <label class="mt20">Groups/On-calls: </label>
                </div>
                <div class="phone-field">
                    <mat-chip-list #chipListGroup [disabled]="disableEditing">
                        <mat-form-field *ngIf="filterField" class="group-filter">
                            <mat-select [formControl]="groupTypeControl" (selectionChange)="getGroupNames(currentGroup)" id="groupTypeSelector">
                                <mat-option value="">
                                    All
                                </mat-option>
                                <mat-option *ngFor="let groupType of groupTypes" [value]="groupType.group_type_id">
                                    {{groupType.group_type}}
                                </mat-option>
                            </mat-select>
                            <mat-hint>Select a group type.</mat-hint>
                        </mat-form-field>
                        <mat-form-field class="phone-number">
                            <mat-chip (click)="openPopup(group)" (removed)="remove(group)"
                                      *ngFor="let group of recipients | callback: filterGroupRecipient.bind(this)"
                                      [removable]="removable" [selectable]="selectable">
                                <mat-checkbox (change)="acknowledgement(group)" (click)='$event.stopPropagation()'
                                              *ngIf="needsAck" [checked]="group.response_required"
                                              [disabled]="group.ack_required" color="primary"
                                              matTooltip="Click to require acknowledgement">
                                </mat-checkbox>
                                <mat-icon matTooltip="Group">supervisor_account</mat-icon>
                                {{group.name}}
                                <mat-icon *ngIf="removable" matChipRemove>cancel</mat-icon>
                            </mat-chip>
                            <!-- Replace with app-autocomplete? -->
                            <input #inputAutoComplete [(ngModel)]="currentGroup" #groupInput (keydown.Tab)="onInputTab($event, 'individual')"
                                   (ngModelChange)="onGroupChanged($event)"
                                   [matAutocomplete]="groupAutocomplete"
                                   [matChipInputAddOnBlur]="addOnBlur"
                                   [matChipInputFor]="chipListGroup"
                                   [matChipInputSeparatorKeyCodes]="separatorKeysCodes" id="groupInput"
                                   matInput>
                            <mat-autocomplete #groupAutocomplete="matAutocomplete"
                                              (optionSelected)="addGroup($event.option.value)"
                                              [displayWith]="''"
                                              autoActiveFirstOption>
                                <mat-option *ngFor="let group of autocompleteGroupsFormatted" [value]="group">
                                    {{ group }}
                                </mat-option>
                            </mat-autocomplete>
                            <mat-hint>Search for a group.</mat-hint>
                        </mat-form-field>
                    </mat-chip-list>
                </div>
            </div>
            <div *ngIf="showIndividualField" class="field-container">
                <div class="recipient-label">
                    <label class="mt20">Individuals: </label>
                </div>
                <div class="individual-group-field">
                    <mat-chip-list #chipList [disabled]="disableEditing">
                        <mat-form-field>
                            <mat-chip (click)="openPopup(individual)" (removed)="remove(individual)"
                                      *ngFor="let individual of recipients | callback: filterIndividualAndDeviceRecipient.bind(this)"
                                      [removable]="removable" [selectable]="selectable">
                                <mat-checkbox (change)="acknowledgement(individual)"
                                              (click)='$event.stopPropagation()' *ngIf="needsAck"
                                              [checked]="individual.response_required"
                                              color="primary"
                                              matTooltip="Click to require acknowledgement">
                                </mat-checkbox>
                                <div [ngSwitch]="individual.member_type || individual.recipient_type"
                                     class="spaced_button">
                                    <mat-icon *ngSwitchCase="'INDIVIDUAL'" matTooltip="Individual">person</mat-icon>
                                    <mat-icon *ngSwitchCase="'DEVICE'" matTooltip="Channel">devices</mat-icon>
                                    <mat-icon *ngSwitchCase="'GROUP'" matTooltip="Group">supervisor_account
                                    </mat-icon>
                                </div>
                                {{individual.name}}
                                <mat-icon *ngIf="removable" matChipRemove>cancel</mat-icon>
                            </mat-chip>
                            <input [(ngModel)]="currentIndividual" #individualInput (keydown.Tab)="onInputTab($event, 'phone')"
                                   (ngModelChange)="onIndividualChanged(individualInput.value)" [matAutocomplete]="autoIndividual"
                                   [matChipInputAddOnBlur]="addOnBlur" [matChipInputFor]="chipList"
                                   [matChipInputSeparatorKeyCodes]="separatorKeysCodes" id="individualInput"
                                   matInput>
                            <mat-autocomplete #autoIndividual="matAutocomplete" #individualAutocomplete
                                              (optionSelected)="addIndividual($event.option.value)"
                                              [displayWith]="''" autoActiveFirstOption>
                                <mat-option *ngFor="let recipient of autocompleteIndFormatted" [value]="recipient">
                                    {{ recipient }}
                                </mat-option>
                            </mat-autocomplete>
                            <mat-hint>Search for a channel or an individual by name.</mat-hint>
                        </mat-form-field>
                    </mat-chip-list>
                </div>
            </div>
            <div *ngIf="needsAck" class="help-text left">(Check the boxes to require acknowledgement)</div>
        </div>
    </mat-card-content>
</mat-card>
